import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./App.css";
import { initErrorReporter } from "./lib/error-reporter";

// Install global error reporter as early as possible so we capture errors
// during initial mount and lazy-chunk loads.
initErrorReporter();

createRoot(document.getElementById("root")!).render(<App />);
